import React from "react";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { MdEmail } from "react-icons/md";
import { FaLinkedinIn } from "react-icons/fa";
import "./index.css";

function SocialMedia() {
  return (
    <div className="social-media">
      <ul className="about-social-links">
        <li className="social-icons">
          <a
            href="https://github.com/Sabal-Subedi/"
            target="_blank"
            rel="noreferrer"
            className="icon-colour  social-icons"
          >
            <AiFillGithub className="social-icon" />
          </a>
        </li>
        <li className="social-icons">
          <a
            href="https://www.linkedin.com/in/subedi-sabal/"
            target="_blank"
            rel="noreferrer"
            className="icon-colour  social-icons"
          >
            <FaLinkedinIn className="social-icon" />
          </a>
        </li>
        <li className="social-icons">
          <a
            href="https://www.instagram.com/sabal.subedi00/"
            target="_blank"
            rel="noreferrer"
            className="icon-colour social-icons"
          >
            <AiFillInstagram className="social-icon" />
          </a>
        </li>
        <li className="social-icons">
          <a
            href="mailto:subedisabal00@gmail.com"
            target="_blank"
            rel="noreferrer"
            className="icon-colour social-icons"
          >
            <MdEmail className="social-icon" />
          </a>
        </li>
      </ul>
    </div>
  );
}
export default SocialMedia;
